import React from "react";
import { Button, Grid, Typography, Box, Container, IconButton, Drawer, List, ListItem, ListItemButton } from "@mui/material";
import { ReactComponent as HomeIcon } from "./assets/home.svg";
import { ReactComponent as VectorIcon } from "./assets/Vector.svg";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import WisdomLogo from "./assets/wisdomLogo.png";
import whiteHeart from "./assets/whiteHeart.png";
import topArrow from "./assets/topArrow.png";
import PostAddOutlinedIcon from '@mui/icons-material/PostAddOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import MenuIcon from '@mui/icons-material/Menu';

import { withTranslation } from 'react-i18next';

import Footer from './components/Footer';
import MobileDrawer from './components/MobileDrawer';
import WebAppHeader from "./components/WebAppHeader";


class About extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      drawerOpen: false,
    };
  }

  toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    this.setState({ drawerOpen: open });
  };

  scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  handleGoHome = () => {
    const eventHandler = this.props.onClickGoToPage("Landing");
    eventHandler();
  };

  changeLanguage = (lng) => {
    this.props.i18n.changeLanguage(lng);
  };

  render() {
     const { t, i18n } = this.props;
    return (
      <>
        {/* Header */}
         <WebAppHeader 
            t={t}
            i18n={i18n}
            view={this.props.view}
            changeLanguage={this.changeLanguage}
            onClickGoToPage={this.props.onClickGoToPage}
            onOpenDrawer={this.toggleDrawer(true)}
            Logo={WisdomLogo}
            icons={{
              HomeIcon,
              InfoOutlinedIcon,
              GroupsOutlinedIcon,
              VectorIcon,
              PostAddOutlinedIcon
            }}
          />

        {/* Mobile Navigation */}
        <MobileDrawer 
          open={this.state.drawerOpen}
          onClose={this.toggleDrawer(false)}
          t={t}
          i18n={i18n} 
          changeLanguage={this.changeLanguage} 
          currentView={this.props.view}
          onClickGoToPage={this.props.onClickGoToPage}
          icons={{
            HomeIcon,
            InfoOutlinedIcon,
            GroupsOutlinedIcon,
            VectorIcon,
            PostAddOutlinedIcon
          }}
        />

        {/* Main Content */}
        <Container
          sx={{
            maxWidth: "1200px",
            margin: "0 auto",
            padding: "20px",
          }}
        >
          {/* Header Section */}
          <Box
            sx={{
              textAlign: "center",
              marginBottom: "40px",
              padding: "30px",
            }}
          >
            <Typography
              variant="h1"
              sx={{
                color: "#221F73",
                fontSize: { md: "2.5rem", sm: "2rem", xs: "1.8rem" },
                marginBottom: "10px",
                fontWeight: "600",
              }}
            >
             {t('about.title')}
            </Typography>
          </Box>

          {/* Team Section */}
          <Box sx={{ marginTop: "50px" }}>
            {/* Principal Investigators */}
            <Typography
              variant="h3"
              sx={{
                textAlign: "center",
                color: "#D80C8C",
                fontSize: { md: "1.8rem", sm: "1.6rem", xs: "1.4rem" },
                margin: "40px 0 30px 0",
                fontWeight: "600",
              }}
            >
              {t('about.section_pi')}
            </Typography>
            
            {/* Grid Container automatically vertical-stretches children elements */}
            <Grid container spacing={4} sx={{ marginBottom: "80px", justifyContent: "center" }}> 
              
              {/* PI Card 1 */}
              <Grid item xs={12} sm={12} md={4} sx={{ display: "flex" }}>
                <Box
                  sx={{
                    background: "white",
                    borderRadius: "20px",
                    padding: "24px",
                    textAlign: "center",
                    boxShadow: "0 8px 25px rgba(0,0,0,0.1)",
                    transition: "transform 0.3s, box-shadow 0.3s",
                    height: "100%",
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    minWidth: { md: "320px" },
                    "&:hover": {
                      transform: "translateY(-5px)",
                      boxShadow: "0 12px 35px rgba(0,0,0,0.15)",
                    },
                  }}
                >
                  <Box
                    sx={{
                      width: "150px",
                      height: "150px",
                      borderRadius: "50%",
                      margin: "0 auto 20px",
                      background: "linear-gradient(135deg, #FDD6EE 0%, #DCE6FB 100%)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      border: "4px solid #FCE4EC",
                      overflow: "hidden",
                      flexShrink: 0,
                    }}
                  >
                    <img
                      src={require("./assets/zoe.png")}
                      alt="Zoë Gottlieb"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        objectPosition: "center",
                      }}
                    />
                  </Box>
                  <Box sx={{ flex: 1, display: "flex", flexDirection: "column" }}>
                    <Typography
                      variant="h4"
                      sx={{
                        color: "#221F73",
                        fontSize: { md: "1.5rem", sm: "1.3rem", xs: "1.2rem" },
                        fontWeight: "600",
                        marginBottom: "15px",
                      }}
                    >
                      Zoë Gottlieb, MD
                    </Typography>
                    <Typography
                      sx={{
                        color: "#D80C8C",
                        fontSize: { md: "1.1rem", sm: "1rem", xs: "0.9rem" },
                        fontWeight: "500",
                        marginBottom: "10px",
                      }}
                    >
                      {t('about.zoe')}
                    </Typography>
                    <Typography
                      sx={{
                        color: "#333",
                        fontSize: { md: "0.95rem", sm: "0.9rem", xs: "0.85rem" },
                        lineHeight: "1.5",
                        textAlign: { xs: "center", sm: "center", md: "left" },
                      }}
                    >
                      •  {t('about.zoe2')}<br/>
                      •  {t('about.zoe3')}
                    </Typography>
                  </Box>
                </Box>
              </Grid>

              {/* PI Card 2 */}
              <Grid item xs={12} sm={12} md={4} sx={{ display: "flex" }}>
                <Box
                  sx={{
                    background: "white",
                    borderRadius: "20px",
                    padding: "24px",
                    textAlign: "center",
                    boxShadow: "0 8px 25px rgba(0,0,0,0.1)",
                    transition: "transform 0.3s, box-shadow 0.3s",
                    height: "100%",
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    minWidth: { md: "320px" },
                    "&:hover": {
                      transform: "translateY(-5px)",
                      boxShadow: "0 12px 35px rgba(0,0,0,0.15)",
                    },
                  }}
                >
                  <Box
                    sx={{
                      width: "150px",
                      height: "150px",
                      borderRadius: "50%",
                      margin: "0 auto 20px",
                      background: "linear-gradient(135deg, #FDD6EE 0%, #DCE6FB 100%)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      border: "4px solid #FCE4EC",
                      overflow: "hidden",
                      flexShrink: 0,
                    }}
                  >
                    <img
                      src={require("./assets/secondImage.png")}
                      alt="Eugenia Shmidt"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        objectPosition: "center",
                      }}
                    />
                  </Box>
                  <Box sx={{ flex: 1, display: "flex", flexDirection: "column" }}>
                    <Typography
                      variant="h4"
                      sx={{
                        color: "#221F73",
                        fontSize: { md: "1.5rem", sm: "1.3rem", xs: "1.2rem" },
                        fontWeight: "600",
                        marginBottom: "15px",
                      }}
                    >
                      Eugenia Shmidt, MD
                    </Typography>
                    <Typography
                      sx={{
                        color: "#D80C8C",
                        fontSize: { md: "1.1rem", sm: "1rem", xs: "0.9rem" },
                        fontWeight: "500",
                        marginBottom: "10px",
                      }}
                    >
                          {t('about.eugenia')}
                    </Typography>
                    <Typography
                      sx={{
                        color: "#333",
                        fontSize: { md: "0.95rem", sm: "0.9rem", xs: "0.85rem" },
                        lineHeight: "1.5",
                        textAlign: { xs: "center", sm: "center", md: "left" },
                      }}
                    >
                      •  {t('about.eugenia2')}<br/>
                      •  {t('about.eugenia3')}
                    </Typography>
                  </Box>
                </Box>
              </Grid>

              {/* PI Card 3 */}
              <Grid item xs={12} sm={12} md={4} sx={{ display: "flex" }}>
                <Box
                  sx={{
                    background: "white",
                    borderRadius: "20px",
                    padding: "24px",
                    textAlign: "center",
                    boxShadow: "0 8px 25px rgba(0,0,0,0.1)",
                    transition: "transform 0.3s, box-shadow 0.3s",
                    height: "100%",
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    minWidth: { md: "320px" },
                    "&:hover": {
                      transform: "translateY(-5px)",
                      boxShadow: "0 12px 35px rgba(0,0,0,0.15)",
                    },
                  }}
                >
                  <Box
                    sx={{
                      width: "150px",
                      height: "150px",
                      borderRadius: "50%",
                      margin: "0 auto 20px",
                      background: "linear-gradient(135deg, #FDD6EE 0%, #DCE6FB 100%)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      border: "4px solid #FCE4EC",
                      overflow: "hidden",
                      flexShrink: 0,
                    }}
                  >
                    <img
                      src={require("./assets/thirdImage.jpg")}
                      alt="Marla Dubinsky"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        objectPosition: "center",
                      }}
                    />
                  </Box>
                  <Box sx={{ flex: 1, display: "flex", flexDirection: "column" }}>
                    <Typography
                      variant="h4"
                      sx={{
                        color: "#221F73",
                        fontSize: { md: "1.5rem", sm: "1.3rem", xs: "1.2rem" },
                        fontWeight: "600",
                        marginBottom: "15px",
                      }}
                    >
                      Marla Dubinsky, MD
                    </Typography>
                    <Typography
                      sx={{
                        color: "#D80C8C",
                        fontSize: { md: "1.1rem", sm: "1rem", xs: "0.9rem" },
                        fontWeight: "500",
                        marginBottom: "10px",
                      }}
                    >
                          {t('about.marla')}
                    </Typography>
                    <Typography
                      sx={{
                        color: "#333",
                        fontSize: { md: "0.95rem", sm: "0.9rem", xs: "0.85rem" },
                        lineHeight: "1.5",
                        textAlign: { xs: "center", sm: "center", md: "left" },
                      }}
                    >
                      •  {t('about.marla2')}<br/>
                      •  {t('about.marla3')}<br/>
                      •  {t('about.marla4')}
                    </Typography>
                  </Box>
                </Box>
              </Grid>
            </Grid>

            {/* Research Team Heading */}
            <Typography
              variant="h3"
              sx={{
                textAlign: "center",
                color: "#D80C8C",
                fontSize: { md: "1.8rem", sm: "1.6rem", xs: "1.4rem" },
                margin: "60px 0 30px 0",
                fontWeight: "600",
              }}
            >
               {t('about.section_staff')}
            </Typography>
            
            {/* Research Team Section with strictly standardized inner Box metrics */}
            <Grid container spacing={4} sx={{ marginBottom: "90px", justifyContent: "center" }}>
              
              {/* Staff Card 1 */}
              <Grid item xs={12} sm={12} md={4} sx={{ display: "flex" }}>
                <Box
                  sx={{
                    background: "white",
                    borderRadius: "20px",
                    boxShadow: "0 8px 25px rgba(0,0,0,0.1)",
                    padding: "24px", 
                    width: "100%",
                    height: "100%", 
                    minWidth: { md: "320px" },
                  }}
                >
                  <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", width: "100%", height: "100%", justifyContent: "flex-start" }}>
                    <Typography
                      variant="h4"
                      sx={{
                        color: "#221F73",
                        fontSize: { md: "1.3rem", sm: "1.2rem", xs: "1.1rem" },
                        fontWeight: "600",
                        marginBottom: "6px",
                        textAlign: "center",
                        width: "100%",
                      }}
                    >
                      Trisha Persaud, MHA
                    </Typography>
                    <Typography
                      variant="h4"
                      sx={{
                        color: "#D80C8C",
                        fontSize: { md: "1.1rem", sm: "1rem", xs: "0.9rem" },
                        fontWeight: "500",
                        marginBottom: "16px",
                        textAlign: "center",
                        width: "100%",
                      }}
                    >
                       {t('about.trisha')}
                    </Typography>
                    <Typography
                      sx={{
                        color: "#333",
                        fontSize: { md: "0.95rem", sm: "0.9rem", xs: "0.85rem" },
                        lineHeight: "1.6",
                        textAlign: "center",
                        width: "100%",
                      }}
                    >
                       {t('about.trisha2')}
                    </Typography>
                  </Box>
                </Box>
              </Grid>

              {/* Staff Card 2 */}
              <Grid item xs={12} sm={12} md={4} sx={{ display: "flex" }}>
                <Box
                  sx={{
                    background: "white",
                    borderRadius: "20px",
                    boxShadow: "0 8px 25px rgba(0,0,0,0.1)",
                    padding: "24px",
                    width: "100%",
                    height: "100%",
                    minWidth: { md: "320px" },
                  }}
                >
                  <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", width: "100%", height: "100%", justifyContent: "flex-start" }}>
                    <Typography
                      variant="h4"
                      sx={{
                        color: "#221F73",
                        fontSize: { md: "1.3rem", sm: "1.2rem", xs: "1.1rem" },
                        fontWeight: "600",
                        marginBottom: "6px",
                        textAlign: "center",
                        width: "100%",
                      }}
                    >
                      Mercury Beiqing Wu, PhD
                    </Typography>
                    <Typography
                      sx={{
                        color: "#D80C8C",
                        fontSize: { md: "1.1rem", sm: "1rem", xs: "0.9rem" },
                        fontWeight: "500",
                        marginBottom: "16px",
                        textAlign: "center",
                        width: "100%",
                      }}
                    >
                       {t('about.mercury')}
                    </Typography>
                    <Typography
                      sx={{
                        color: "#333",
                        fontSize: { md: "0.95rem", sm: "0.9rem", xs: "0.85rem" },
                        lineHeight: "1.6",
                        textAlign: "center",
                        width: "100%",
                      }}
                    >
                         {t('about.mercury2')}
                    </Typography>
                  </Box>
                </Box>
              </Grid>

              {/* Staff Card 3 */}
              <Grid item xs={12} sm={12} md={4} sx={{ display: "flex" }}>
                <Box
                  sx={{
                    background: "white",
                    borderRadius: "20px",
                    boxShadow: "0 8px 25px rgba(0,0,0,0.1)",
                    padding: "24px",
                    width: "100%",
                    height: "100%",
                    minWidth: { md: "320px" },
                  }}
                >
                  <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", width: "100%", height: "100%", justifyContent: "flex-start" }}>
                    <Typography
                      variant="h4"
                      sx={{
                        color: "#221F73",
                        fontSize: { md: "1.3rem", sm: "1.2rem", xs: "1.1rem" },
                        fontWeight: "600",
                        marginBottom: "6px",
                        textAlign: "center",
                        width: "100%",
                      }}
                    >
                      Drew Helmus, MPH, MA
                    </Typography>
                    <Typography
                      sx={{
                        color: "#D80C8C",
                        fontSize: { md: "1.1rem", sm: "1rem", xs: "0.9rem" },
                        fontWeight: "500",
                        marginBottom: "16px",
                        textAlign: "center",
                        width: "100%",
                      }}
                    >
                         {t('about.drew')}
                    </Typography>
                    <Typography
                      sx={{
                        color: "#333",
                        fontSize: { md: "0.95rem", sm: "0.9rem", xs: "0.85rem" },
                        lineHeight: "1.6",
                        textAlign: "center",
                        width: "100%",
                      }}
                    >
                      {t('about.drew2')}
                    </Typography>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Box>

          {/* Collaborating Partners */}
          <Box
            sx={{
              background: "white",
              padding: "40px",
              borderRadius: "20px",
              boxShadow: "0 8px 25px rgba(0,0,0,0.1)",
              marginBottom: "30px",
            }}
          >
            <Typography
              variant="h2"
              sx={{
                color: "#D80C8C",
                fontSize: { md: "1.8rem", sm: "1.6rem", xs: "1.4rem" },
                marginBottom: "20px",
                fontWeight: "600",
              }}
            >
               {t('about.section_collaborators')}
            </Typography>
            <Grid container spacing={3}>
              {(() => {
                const partners = [
                  "Advent Health Orlando",
                  "Beth Israel Deaconess Medical Center",
                  "Boston Medical Center",
                  "Brigham and Women's Hospital",
                  "Capital Digestive GI",
                  "Cedars Sinai",
                  "Cleveland Clinic",
                  "Colon & Rectal Surgery Associates",
                  "Cornell University",
                  "Emory University",
                  "Houston Methodist",
                  "Johns Hopkins University",
                  "Kaiser Permanente Washington",
                  "Mayo Clinic Arizona",
                  "Mayo Clinic Jacksonville",
                  "Mayo Clinic Rochester",
                  "MNGI",
                  "Massachusetts General Hospital",
                  "Northwestern University",
                  "New York University",
                  "University of Pennsylvania",
                  "Penn State",
                  "Reproductive Medical Associates of NY",
                  "Rutgers University",
                  "Stanford University",
                  "The IBD Centre of British Columbia",
                  "Tufts University",
                  "Tulane University",
                  "University of California, Irvine",
                  "University of California, Los Angeles",
                  "University of California, San Diego",
                  "University of California, San Francisco",
                  "University of Calgary",
                  "University of Chicago",
                  "University of Cincinnati",
                  "University of Florida",
                  "University of Miami",
                  "University of North Carolina at Chapel Hill",
                  "University of Toronto",
                  "University of Utah",
                  "University of Washington",
                  "University of Wisconsin",
                  "Vanderbilt University",
                  "Washington University",
                  "Yale University"
                ].sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()));
                
                const itemsPerColumn = Math.ceil(partners.length / 3);
                const columns = [
                  partners.slice(0, itemsPerColumn),
                  partners.slice(itemsPerColumn, itemsPerColumn * 2),
                  partners.slice(itemsPerColumn * 2)
                ];
                
                return columns.map((column, columnIndex) => (
                  <Grid item xs={12} md={4} key={columnIndex}>
                    {column.map((partner, index) => (
                      <Typography
                        key={`${columnIndex}-${index}`}
                        sx={{
                          background: "none",
                          padding: "8px 0",
                          textAlign: "left",
                          fontSize: "1rem",
                          fontWeight: "400",
                          color: "#333",
                          borderBottom: "1px solid #eee",
                        }}
                      >
                        {partner}
                      </Typography>
                    ))}
                  </Grid>
                ));
              })()}
            </Grid>
          </Box>
        </Container>

        {/* Footer */}
         <Footer 
            t={t} 
            onClickGoToPage={this.props.onClickGoToPage} 
            whiteHeart={whiteHeart} 
            topArrow={topArrow} 
          />
      </>
    );
  }
}

export default withTranslation()(About);